module.exports = __webpack_public_path__ + "static/image3-d7b0685c91e85a958f381a082a1f0b9f.jpg";